(() => {
  const SELECTOR = '[data-quantity-offer-selector]';
  const BUTTON_SELECTOR = '[data-quantity-offer-button]';
  const BENEFIT_SELECTOR = '[data-quantity-offer-benefit]';
  const BENEFIT_TEXT_SELECTOR = '[data-quantity-offer-benefit-text]';
  const ACTIVE_CLASS = 'is-active';

  function parseIntSafe(value) {
    const n = Number.parseInt(value, 10);
    return Number.isFinite(n) ? n : null;
  }

  function findQuantityInput(container) {
    const inputId = container?.dataset?.quantityInputId;
    if (inputId) {
      const byId = document.getElementById(inputId);
      if (byId && byId.matches('input[name="quantity"]')) return byId;
    }

    const productInfo = container.closest('product-info');
    return productInfo?.querySelector('input[name="quantity"]') || null;
  }

  function clampToRules(input, qty) {
    if (!input) return qty;
    const min = parseIntSafe(input.getAttribute('min') || input.dataset?.min);
    const max = parseIntSafe(input.getAttribute('max') || input.dataset?.max);

    let next = qty;
    if (min != null) next = Math.max(min, next);
    if (max != null) next = Math.min(max, next);
    return next;
  }

  function dispatchQuantityEvents(input) {
    if (!input) return;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function determineActiveQty(container, currentQty) {
    if (currentQty == null) return null;
    let best = null;
    container.querySelectorAll(BUTTON_SELECTOR).forEach((btn) => {
      const btnQty = parseIntSafe(btn.dataset.quantity);
      if (btnQty == null) return;
      if (btnQty <= currentQty && (best == null || btnQty > best)) best = btnQty;
    });
    return best;
  }

  function updateBenefit(container, activeButton) {
    const benefitEl = container.querySelector(BENEFIT_SELECTOR);
    const benefitTextEl = container.querySelector(BENEFIT_TEXT_SELECTOR);
    if (!benefitEl || !benefitTextEl) return;

    const text = activeButton?.dataset?.benefit || '';
    const normalized = String(text).trim().toLowerCase();
    const show = Boolean(normalized.length > 0);
    const isOffer = show && normalized !== 'no offer' && normalized !== 'no offers';

    benefitTextEl.textContent = show ? text : '';
    benefitEl.hidden = !show;
    benefitEl.dataset.kind = isOffer ? 'offer' : 'neutral';

    const icon = benefitEl.querySelector('.quantity-offer-selector__benefit-icon');
    if (icon) icon.hidden = !isOffer;
  }

  function setActive(container, activeQty) {
    let activeButton = null;
    container.querySelectorAll(BUTTON_SELECTOR).forEach((btn) => {
      const btnQty = parseIntSafe(btn.dataset.quantity);
      const isActive = btnQty != null && activeQty != null && btnQty === activeQty;
      btn.classList.toggle(ACTIVE_CLASS, isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) activeButton = btn;
    });
    updateBenefit(container, activeButton);
  }

  function syncFromInput(container) {
    const input = findQuantityInput(container);
    if (!input) return;
    const currentQty = parseIntSafe(input.value);
    const activeQty = determineActiveQty(container, currentQty);
    setActive(container, activeQty);
  }

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(BUTTON_SELECTOR) : null;
    if (!button) return;

    const container = button.closest(SELECTOR);
    if (!container) return;

    const input = findQuantityInput(container);
    if (!input) return;

    const qty = parseIntSafe(button.dataset.quantity);
    if (qty == null) return;

    const nextQty = clampToRules(input, qty);
    input.value = String(nextQty);
    dispatchQuantityEvents(input);
    const activeQty = determineActiveQty(container, nextQty);
    setActive(container, activeQty);
  });

  function handleQuantityEvent(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.name !== 'quantity') return;

    const productInfo = target.closest('product-info') || document;
    productInfo.querySelectorAll(SELECTOR).forEach((container) => syncFromInput(container));
  }

  document.addEventListener('input', handleQuantityEvent);
  document.addEventListener('change', handleQuantityEvent);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTOR).forEach((container) => syncFromInput(container));
  });
})();

